// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__2HXSz","header":"Cart_header__2VRzl","body":"Cart_body__Bp11B","footer":"Cart_footer__6fTJQ"};